import React, { Component } from "react";
import PatientSidebar from "../patienttsidebar";
import { Link } from "react-router-dom";
import { Tab, Tabs, Modal } from "react-bootstrap";

import { IMG_fe_01, IMG_fe_02, IMG_fe_03, IMG_fe_04 } from "./img";
import Lightbox from "fslightbox-react";
import { getReservasByClienteV2 } from "../../functions.js";

import Loader from "../../Loader";

class PatientProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: 1,
      bookings: [],
      campos2: [
        {
          label: "Evolución (según paciente)",
          tipo: "textarea",
          nombre: "evolucion",
        },
        {
          label: "Examen físico general",
          tipo: "textarea",
          nombre: "examenfísicogeneral",
        },
        {
          label: "Examen físico dermatológico",
          tipo: "textarea",
          nombre: "examenfísicodermatologico",
        },
        {
          label: "Dermatoscopia / tricoscopia",
          tipo: "textarea",
          nombre: "dermatoscopiatricoscopia",
        },
        {
          label: "Estudios complementarios",
          tipo: "textarea",
          nombre: "estudioscomplementarios",
        },
        {
          label: "Escala de puntuación / Score",
          tipo: "textarea",
          nombre: "escaladepuntuacionscore",
        },
        {
          label: "Diagnósticos presuntivos",
          tipo: "textarea",
          nombre: "diagnosticospresuntivos",
        },
        {
          label: "Nota o comentario",
          tipo: "textarea",
          nombre: "notaocomentario",
        },
        {
          label: "Tratamiento o conducta",
          tipo: "textarea",
          nombre: "tratamientooconducta",
        },
        {
          label: "Próximo control",
          tipo: "textarea",
          nombre: "proximocontrol",
        },
      ],
      campos3: [
        {
          label: "¿Se entregó consentimiento informado del procedimiento?",
          tipo: "radio",
          nombre: "entregoconsentimiento",
        },
        {
          label: "Diagnósticos presuntivos",
          tipo: "textarea",
          nombre: "diagnosticospresuntivos",
        },
        {
          label: "Procedimiento a realizar",
          tipo: "textarea",
          nombre: "procedimientoarealizar",
        },
        { label: "Protocolo", tipo: "textarea", nombre: "protocolo" },
        {
          label: "Complicaciones durante el procedimiento",
          tipo: "radio",
          nombre: "complicacionesduranteelprocedimiento",
        },
        { label: "Indicaciones", tipo: "textarea", nombre: "indicaciones" },
      ],
      campos: [
        {
          label: "Historia de enfermedad actual",
          tipo: "textarea",
          nombre: "historiadeenfermedadactual",
        },
        {
          label: "Antecedentes patológicos",
          tipo: "textarea",
          nombre: "antecedentespatologicos",
        },
        {
          label: "Antecedentes familiares",
          tipo: "textarea",
          nombre: "antecedentesfamiliares",
        },
        {
          label: "Examen físico general",
          tipo: "textarea",
          nombre: "examenfisicogeneral",
        },
        {
          label: "Examen físico dermatológico",
          tipo: "textarea",
          nombre: "examenfisicodermatologico",
        },
        {
          label: "Dermatoscopia / tricoscopia",
          tipo: "textarea",
          nombre: "dermatoscopiatricoscopia",
        },
        {
          label: "Estudios complementarios",
          tipo: "textarea",
          nombre: "estudioscomplementarios",
        },
        {
          label: "Escala de puntuación / Score",
          tipo: "textarea",
          nombre: "escaladepuntuacionscore",
        },
        {
          label: "Diagnósticos presuntivos",
          tipo: "textarea",
          nombre: "diagnosticospresuntivos",
        },
        {
          label: "Tratamiento o conducta",
          tipo: "textarea",
          nombre: "tratamientooconducta",
        },
        {
          label: "Proximo control",
          tipo: "textarea",
          nombre: "proximocontrol",
        },
        {
          label: "Nota o comentario",
          tipo: "textarea",
          nombre: "notaocomentario",
        },
      ],
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(key) {
    this.setState({ key });
  }
  handleClose = () => {
    this.setState({
      show: false,
    });
  };

  componentDidMount = async () => {
    const fecha = new Date();

    //console.log(fecha)

    this.setState({ isExecuting: true, fechaFormateada: fecha });

    const fullPath = window.location.href;

    let forcedKey;
    if (fullPath.indexOf("id_producto_cliente") >= 0) {
      let _fullPath = fullPath.split("id_producto_cliente=");
      forcedKey = _fullPath[1];
    }

    //    console.log("forcedKey", forcedKey);

    if (forcedKey) {
      this.setState({
        ...this.state,
        forcedKey: forcedKey,
      });
    }
    var customerDocumentId = this.props.match.params.customerDocumentId;

    let respReservas = await getReservasByClienteV2(customerDocumentId);
    console.log(respReservas);

    this.setState({ isExecuting: false, bookings: respReservas.reservas });
  };

  handleShow = () => {
    this.setState({
      show: true,
    });
  };
  render() {
    return (
      <div>
        <Loader idLoading={this.state.isExecuting} />
        <div className="breadcrumb-bar">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-md-12 col-12">
                <nav aria-label="breadcrumb" className="page-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/home">Inicio</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Perfil
                    </li>
                  </ol>
                </nav>
                <h2 className="breadcrumb-title">Perfil del paciente</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar dct-dashbd-lft">
                <PatientSidebar />
              </div>
              <div className="col-md-7 col-lg-8 col-xl-9 dct-appoinment">
                <div className="card">
                  <div className="card-body pt-3">
                    <Tabs
                      className="tab-view"
                      activeKey={this.state.key}
                      onSelect={this.handleSelect}
                      id="controlled-tab-example"
                    >
                      <Tab className="nav-item" eventKey={1} title="CITAS">
                        <div className="card card-table mb-0">
                          <div className="card-body">
                            <div className="table-responsive">
                              <table className="table table-hover table-center mb-0">
                                <thead>
                                  <tr>
                                    <th>Consultorio</th>
                                    <th>Fecha</th>
                                    <th>Hora</th>
                                    <th>Servicio</th>
                                    <th>Precio</th>
                                    <th>Estado</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.bookings.map((item) => (
                                    <tr>
                                      <td>
                                        <h2 className="table-avatar">
                                          {item.descReserva.consultorio}
                                        </h2>
                                      </td>
                                      <td>{item.descReserva.fecha_registro}</td>
                                      <td> {item.descReserva.hora_reserva}</td>
                                      <td>
                                        {item.descReserva.servicio ||
                                          item.id_servicio}
                                      </td>
                                      <td>{item.monto}</td>
                                      <td>
                                        <span
                                          className={
                                            "badge badge-pill bg-" +
                                            (item.estado === "ACTIVA"
                                              ? "success"
                                              : "danger") +
                                            "-light"
                                          }
                                        >
                                          {item.estado}
                                        </span>
                                      </td>
                                      <td className="text-right">
                                        <div className="table-action">
                                          <a
                                            href="#0"
                                            className="btn btn-sm bg-info-light"
                                          >
                                            <i className="far fa-eye"></i>{" "}
                                            Cerrar
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      <Tab className="nav-item" eventKey={2} title="HISTORIA">
                        <h3 className="text-center"> HISTORIA CLÍNICA </h3>
                        <div className="text-right">
                          <a
                            href="#0"
                            className="add-new-btn"
                            onClick={this.handleShow}
                            data-target="#add_medical_records"
                          >
                            Agregar Fotos
                          </a>
                        </div>
                        <div className="card card-table mb-0">
                          <div className="card-body ml-2 mr-2">
                            <div className="row">
                              <div className="col-md-6 col-sm-12">
                                <div className="form-group card-label">
                                  <label>Procedencia</label>
                                  <input
                                    className={"form-control"}
                                    type="text"
                                    name="procedencia"
                                    value={this.state.procedencia}
                                    onChange={this.changeHandler}
                                  />
                                </div>
                              </div>
                              <div className="col-md-6 col-sm-12">
                                <div className="form-group card-label">
                                  <label>Ocupación </label>
                                  <input
                                    className={"form-control "}
                                    type="text"
                                    name="ocupacion"
                                    value={this.state.ocupacion}
                                    onChange={this.changeHandler}
                                  />
                                </div>
                              </div>
                            </div>
                            {this.state.campos.map((item) => (
                              <div className="row">
                                <div className="col-md-12 col-sm-12">
                                  <div className="form-group card-label">
                                    <label>{item.label}</label>
                                    <textarea
                                      className={"form-control"}
                                      name={item.nombre}
                                      value={this.state[item.nombre]}
                                      onChange={this.changeHandler}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}

                            <div className="text-right">
                              <Link
                                to="/add-prescription"
                                className="add-new-btn"
                              >
                                Guardar Datos
                              </Link>
                            </div>

                            
                          <div className="clinic-details pl-3 pr-3">
                            <Lightbox
                              toggler={this.state.isOpen}
                              sources={[
                                "https://charlestondermatology.com/wp-content/uploads/2023/03/skin-care.png",
                                "https://s3-us-west-2.amazonaws.com/utsw-patientcare-web-production/original_images/general-dermatology-1600x732.jpg",
                                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR0O3-pwuyYRqHHYEBYQPK4sK3n1WG-CLjIyGWOmEx4Q&s",
                                "https://cdn-5ec6deb4c1ac18016c054cdc.closte.com/wp-content/uploads/2020/06/urgent-dermatology-care-Greenvale.jpg",
                              ]}
                              customAttributes={[
                                {
                                  alt: "An example description.",
                                  foo: "bar",
                                },
                              ]}
                            />

                            <ul className="clinic-gallery">
                              <li>
                                <a
                                  href="#0"
                                  onClick={() =>
                                    this.setState({
                                      isOpen: !this.state.isOpen,
                                      photoIndex: 0,
                                    })
                                  }
                                >
                                  <img
                                    src={
                                      "https://charlestondermatology.com/wp-content/uploads/2023/03/skin-care.png"
                                    }
                                    alt="Feature"
                                  />
                                </a>
                              </li>

                              <li>
                                <a
                                  href="#0"
                                  onClick={() =>
                                    this.setState({
                                      isOpen: !this.state.isOpen,
                                      photoIndex: 0,
                                    })
                                  }
                                >
                                  <img
                                    src={
                                      "https://s3-us-west-2.amazonaws.com/utsw-patientcare-web-production/original_images/general-dermatology-1600x732.jpg"
                                    }
                                    alt="Feature"
                                  />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="#0"
                                  onClick={() =>
                                    this.setState({
                                      isOpen: !this.state.isOpen,
                                      photoIndex: 0,
                                    })
                                  }
                                >
                                  <img
                                    src={
                                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR0O3-pwuyYRqHHYEBYQPK4sK3n1WG-CLjIyGWOmEx4Q&s"
                                    }
                                    alt="Feature"
                                  />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="#0"
                                  onClick={() =>
                                    this.setState({
                                      isOpen: !this.state.isOpen,
                                      photoIndex: 0,
                                    })
                                  }
                                >
                                  <img
                                    src={
                                      "https://cdn-5ec6deb4c1ac18016c054cdc.closte.com/wp-content/uploads/2020/06/urgent-dermatology-care-Greenvale.jpg"
                                    }
                                    alt="Feature"
                                  />
                                </a>
                              </li>
                            </ul>
                          </div>
                        

                          </div>
                        </div>
                      </Tab>
                      <Tab className="nav-item" eventKey={3} title="CONTROL">
                        <h3 className="text-center">CONTROL (DERMATOLOGÍA) </h3>
                        <div className="text-right">
                          <a
                            href="#0"
                            className="add-new-btn"
                            onClick={this.handleShow}
                            data-target="#add_medical_records"
                          >
                            Agregar Fotos
                          </a>
                        </div>
                        <div className="card card-table mb-0">
                          <div className="card-body ml-2 mr-2">
                            {this.state.campos2.map((item) => (
                              <div className="row">
                                <div className="col-md-12 col-sm-12">
                                  <div className="form-group card-label">
                                    <label>{item.label}</label>
                                    <textarea
                                      className={"form-control"}
                                      name={item.nombre}
                                      value={this.state[item.nombre]}
                                      onChange={this.changeHandler}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}

                            <div className="text-right">
                              <Link
                                to="/add-prescription"
                                className="add-new-btn"
                              >
                                Guardar Datos
                              </Link>
                            </div>
                          </div>

                          <div className="clinic-details pl-3 pr-3">
                            <Lightbox
                              toggler={this.state.isOpen}
                              sources={[
                                "https://charlestondermatology.com/wp-content/uploads/2023/03/skin-care.png",
                                "https://s3-us-west-2.amazonaws.com/utsw-patientcare-web-production/original_images/general-dermatology-1600x732.jpg",
                                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR0O3-pwuyYRqHHYEBYQPK4sK3n1WG-CLjIyGWOmEx4Q&s",
                                "https://cdn-5ec6deb4c1ac18016c054cdc.closte.com/wp-content/uploads/2020/06/urgent-dermatology-care-Greenvale.jpg",
                              ]}
                              customAttributes={[
                                {
                                  alt: "An example description.",
                                  foo: "bar",
                                },
                              ]}
                            />

                            <ul className="clinic-gallery">
                              <li>
                                <a
                                  href="#0"
                                  onClick={() =>
                                    this.setState({
                                      isOpen: !this.state.isOpen,
                                      photoIndex: 0,
                                    })
                                  }
                                >
                                  <img
                                    src={
                                      "https://charlestondermatology.com/wp-content/uploads/2023/03/skin-care.png"
                                    }
                                    alt="Feature"
                                  />
                                </a>
                              </li>

                              <li>
                                <a
                                  href="#0"
                                  onClick={() =>
                                    this.setState({
                                      isOpen: !this.state.isOpen,
                                      photoIndex: 0,
                                    })
                                  }
                                >
                                  <img
                                    src={
                                      "https://s3-us-west-2.amazonaws.com/utsw-patientcare-web-production/original_images/general-dermatology-1600x732.jpg"
                                    }
                                    alt="Feature"
                                  />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="#0"
                                  onClick={() =>
                                    this.setState({
                                      isOpen: !this.state.isOpen,
                                      photoIndex: 0,
                                    })
                                  }
                                >
                                  <img
                                    src={
                                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR0O3-pwuyYRqHHYEBYQPK4sK3n1WG-CLjIyGWOmEx4Q&s"
                                    }
                                    alt="Feature"
                                  />
                                </a>
                              </li>
                              <li>
                                <a
                                  href="#0"
                                  onClick={() =>
                                    this.setState({
                                      isOpen: !this.state.isOpen,
                                      photoIndex: 0,
                                    })
                                  }
                                >
                                  <img
                                    src={
                                      "https://cdn-5ec6deb4c1ac18016c054cdc.closte.com/wp-content/uploads/2020/06/urgent-dermatology-care-Greenvale.jpg"
                                    }
                                    alt="Feature"
                                  />
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Tab>
                      <Tab
                        className="nav-item"
                        eventKey={4}
                        title="NOTA PROCEDIMIENTO"
                      >
                        <h3 className="text-center">
                          NOTA PROCEDIMIENTO DERMATOLOGÍA
                        </h3>
                        <div className="text-right">
                          <a
                            href="#0"
                            className="add-new-btn"
                            onClick={this.handleShow}
                            data-target="#add_medical_records"
                          >
                            Agregar Fotos
                          </a>
                        </div>

                        <div className="card card-table mb-0">
                          <div className="card-body ml-2 mr-2">
                            {this.state.campos3.map((item) => (
                              <div className="row">
                                <div className="col-md-12 col-sm-12">
                                  <div className="form-group card-label">
                                    <label>{item.label}</label>
                                    <textarea
                                      className={"form-control"}
                                      name={item.nombre}
                                      value={this.state[item.nombre]}
                                      onChange={this.changeHandler}
                                    />
                                  </div>
                                </div>
                              </div>
                            ))}

                            <div className="text-right">
                              <Link
                                to="/add-prescription"
                                className="add-new-btn"
                              >
                                Guardar Datos
                              </Link>
                            </div>

                            <div className="clinic-details pl-3 pr-3">
                              <Lightbox
                                toggler={this.state.isOpen}
                                sources={[
                                  "https://charlestondermatology.com/wp-content/uploads/2023/03/skin-care.png",
                                  "https://s3-us-west-2.amazonaws.com/utsw-patientcare-web-production/original_images/general-dermatology-1600x732.jpg",
                                  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR0O3-pwuyYRqHHYEBYQPK4sK3n1WG-CLjIyGWOmEx4Q&s",
                                  "https://cdn-5ec6deb4c1ac18016c054cdc.closte.com/wp-content/uploads/2020/06/urgent-dermatology-care-Greenvale.jpg",
                                ]}
                                customAttributes={[
                                  {
                                    alt: "An example description.",
                                    foo: "bar",
                                  },
                                ]}
                              />

                              <ul className="clinic-gallery">
                                <li>
                                  <a
                                    href="#0"
                                    onClick={() =>
                                      this.setState({
                                        isOpen: !this.state.isOpen,
                                        photoIndex: 0,
                                      })
                                    }
                                  >
                                    <img
                                      src={
                                        "https://charlestondermatology.com/wp-content/uploads/2023/03/skin-care.png"
                                      }
                                      alt="Feature"
                                    />
                                  </a>
                                </li>

                                <li>
                                  <a
                                    href="#0"
                                    onClick={() =>
                                      this.setState({
                                        isOpen: !this.state.isOpen,
                                        photoIndex: 0,
                                      })
                                    }
                                  >
                                    <img
                                      src={
                                        "https://s3-us-west-2.amazonaws.com/utsw-patientcare-web-production/original_images/general-dermatology-1600x732.jpg"
                                      }
                                      alt="Feature"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="#0"
                                    onClick={() =>
                                      this.setState({
                                        isOpen: !this.state.isOpen,
                                        photoIndex: 0,
                                      })
                                    }
                                  >
                                    <img
                                      src={
                                        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR0O3-pwuyYRqHHYEBYQPK4sK3n1WG-CLjIyGWOmEx4Q&s"
                                      }
                                      alt="Feature"
                                    />
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href="#0"
                                    onClick={() =>
                                      this.setState({
                                        isOpen: !this.state.isOpen,
                                        photoIndex: 0,
                                      })
                                    }
                                  >
                                    <img
                                      src={
                                        "https://cdn-5ec6deb4c1ac18016c054cdc.closte.com/wp-content/uploads/2020/06/urgent-dermatology-care-Greenvale.jpg"
                                      }
                                      alt="Feature"
                                    />
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton={true}>
            <Modal.Title>Subir imagenes</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form-group">
              <label>Upload File</label>
              <input type="file" className="form-control" />
            </div>
            <div className="submit-section text-center">
              <button type="submit" className="btn btn-primary submit-btn">
                Subir
              </button>
              <button
                type="button"
                className="btn btn-secondary submit-btn"
                data-dismiss="modal"
                onClick={() => {
                  this.setState({
                    show: !this.state.show,
                  });
                }}
              >
                Cancelar
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default PatientProfile;
